export default __webpack_public_path__ + "static/media/PrimaryButtonRect2.5e7ba04a.svg";